import React from 'react';
import { connect } from 'react-redux';
import dataModel from '../../../models/DataModel';
import TextMap from '../../../helpers/TextMap';
import ReportHeader from '../../../containers/ManagerDashboard/ReportHeader';
import LoadingDots from '../../../components/LoadingDots';

import DocumentPopup from '../../../components/DocumentPopup';
import TableHeader from '../../../components/Table/TableHeader';
import TableRow from '../../../components/Table/TableRow';
import AnalyticsLogger from '../../../helpers/analytics/analyticsLogger';
import CollectionDataSource from '../../../dao/DataSource/CollectionDataSource';
import ReportFilter from '../../../containers/ManagerDashboard/ReportFilter';
import CloseoutReportFilters from './CloseoutReportFilters';
import anime from 'animejs';

import './CloseoutSummary.scss';
import { isNull } from 'lodash';

// This data source serves Closeout records, so the descriptor has to be closeout
// shaped. It used to be a copy of the Projects summary descriptor (project_manager,
// project_users, location, project_contacts, ...). The closeout-summary endpoint
// hard-codes its own fields and ignores ?filtering=, so the list request never
// noticed - but CollectionDataSource also registers this descriptor with the
// ActionCable connector, which replays it on GET /closeouts/:id when an
// updateCloseout event lands. CloseoutSerializer declares none of those
// relationships, so every refresh 500'd and the preview modal came up empty.
const closeout_summary_descriptor = {
  closeouts: {},
};
export class CloseoutSummary extends React.Component {
  constructor(props) {
    super(props);
    
    this.textMap = new TextMap();
    this.accent = this.props.currentCompany.accent_color ? this.props.currentCompany.accent_color : '#CD03A';
    this.state = {
      closeouts: [],
      selectedCloseouts: [], // ids only
      selectedCloseoutsNames: [], //name for single 
      exportLink: null,
      loadingCloseouts: true,
      selectedCloseout: null,
      displayPopUp: null,
      fileName: null,
      closeoutFilename: null,
      filterActive: false,
    };

    this.handleSort = this.handleSort.bind(this);
    this.changeSort = this.changeSort.bind(this);
    this.selectCloseout = this.selectCloseout.bind(this);
    this.displayCloseout = this.displayCloseout.bind(this);
    this.handleLogExport = this.handleLogExport.bind(this);
    this.handleCloseoutsRetrieval = this.handleCloseoutsRetrieval.bind(this);
    this.handleDownloadLocation = this.handleDownloadLocation.bind(this);
    this.changeFileName = this.changeFileName.bind(this);
    this.handleClosePopup = this.handleClosePopup.bind(this);
    this.handleFilterActive = this.handleFilterActive.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleApplyFilter = this.handleApplyFilter.bind(this);
  }

  //to filenamepopup
  changeFileName(value) {
    this.setState({ fileName: value , 
      exportLink: `${process.env.REACT_APP_API}/zip-closeouts?closeouts=${this.state.selectedCloseouts}&filename=${encodeURIComponent(value)}&current_company=${localStorage.current_company_id}&token=${localStorage.token}`,
    });
    
  }

  handleDownloadLocation() {
    
    this.setState({ displayPopUp: true });
    return; 
  }

  handleClosePopup() {
    this.setState({ displayPopUp: false });
  }
  //end

  handleCloseoutsRetrieval(closeouts, action, acData, fetchedData) {
    this.setState({ closeouts: closeouts.closeouts, loadingCloseouts: false });
  }

  handleInitializeDataSource() {
    if (this.closeoutsDataSource) {
      this.closeoutsDataSource.release();
      this.closeoutsDataSource = null;
    }
    this.closeoutsDataSource = new CollectionDataSource('CloseoutsSummaryCollection', 'Closeout', closeout_summary_descriptor, this.handleCloseoutsRetrieval, 'CloseoutSummary',
    null, '', this.props.currentUser.id, this.props.currentCompany.id, 'closeout-summary', {});

    let collectionFilter = this.closeoutsDataSource.filter;
    if (!collectionFilter) {
      collectionFilter = {};
    }
    collectionFilter.sortField = 'created_at';
    collectionFilter.ascending = false;
    this.closeoutsDataSource.filter = collectionFilter;
    this.closeoutsDataSource.page = 1;
    this.closeoutsDataSource.perPage = Math.ceil(this.closeoutTableContainer.offsetHeight / 73); //73 is the row size

    this.infiniteDone = false;

    this.setState({
      filterDisplayed: collectionFilter.filterDisplayed || false,
    });
  }

  handleFilterActive(filterDisplayed){
    console.log('work');
    if (!this.filterInProgress) {
      this.filterInProgress = true;
      if (filterDisplayed) {
        anime({
          targets: '.ReportFilter',
          height: 224,
          easing: 'easeInOutCubic',
          duration: 500,
          begin: () => {
            this.setState({ filterDisplayed: true });
          },
          complete: () => {
            this.filterInProgress = false;
          },
        });
      }
      else {
        anime({
          targets: '.ReportFilter',
          height: 0,
          easing: 'easeInOutCubic',
          duration: 500,
          complete: () => {
            this.setState({ filterDisplayed: false });
            this.filterInProgress = false;
          },
        });
      }

      let filter = this.closeoutsDataSource.filter;
      filter.filterDisplayed = filterDisplayed;
      this.closeoutsDataSource.filter = { ...filter };
    }
  }

  handleApplyFilter(filter) {
    if (filter && ((filter.project_types && filter.project_types.length > 0) || (filter.project_managers && filter.project_managers.length > 0)
        || (filter.statuses && filter.statuses.length > 0) || (filter.types && filter.types.length > 0) || (filter.closeout_users && filter.closeout_users.length > 0)
        || (filter.startDate || filter.endDate))) {
      // the nonsense below is to ensure we only log events when filters
      // are applied (not cleared, etc.)
      const newFilterStats = {
        projectTypeCount: filter.project_types ? filter.project_types.length : 0,
        projectManagerCount: filter.project_managers ? filter.project_managers.length : 0,
        projectStatusCount: filter.statuses ? filter.statuses.length : 0,
        typesCount: filter.types ? filter.types.length : 0,
        closeoutUserCount: filter.closeout_users ? filter.closeout_users.length : 0,
        startDate: filter.startDate ? filter.startDate : null,
        endDate: filter.endDate ? filter.endDate : null,
      };
      this.filterStats = newFilterStats;
      this.closeoutsDataSource.filter = { ...filter };
      this.setState({ filterActive: true });
    }
    else if (filter.filterDisplayed) {
      this.closeoutsDataSource.filter = { ...filter };
      //if it got here, that means that no filters were set
      this.setState({ filterActive: false });
    }
    else {
      this.closeoutsDataSource.filter = { ...null };
      this.setState({ filterActive: false });
    }
    this.setState({ loadingMore: true });
    this.closeoutsDataSource.current();
  }

  handleFilterChange(filter) {
    this.closeoutsDataSource.filter = filter;
    this.handleApplyFilter(this.closeoutsDataSource.filter, true);
  }

  componentDidMount() {
    const currentRole = dataModel.usersDAO.currentUser ? dataModel.usersDAO.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });

    this.handleInitializeDataSource();

    this.setState({
      loadingCloseouts: true,
    });

    if (this.state.filterDisplayed) {
      this.handleFilterActive(true, true);
    }
    this.handleApplyFilter(this.closeoutsDataSource.filter, false);
    this.closeoutsDataSource.current();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.currentCompany.id != this.props.currentCompany.id) {
      this.handleInitializeDataSource();
    }
  }

  componentWillUnmount() {
    if (this.closeoutsDataSource) {
      this.closeoutsDataSource.release();
      this.closeoutsDataSource = null;
    }
  }

  handleSort(type, direction) {
    if (type == this.state.sortField && direction == 'up' && this.state.ascending) {
      this.setState({ ascending: true });
      this.changeSort(this.state.sortField, true);
    }
    else if (type == this.state.sortField && direction == 'down' && !this.state.ascending) {
      this.setState({ ascending: true });
      this.changeSort(this.state.sortField, true);
    }
    else {
      this.changeSort(type, direction == 'up' ? true : false);

      this.setState({
        sortField: type,
        ascending: direction == 'up' ? true : false,
      });
    }
  }

  changeSort(sortField, ascending) {
    const collectionFilter = this.closeoutsDataSource.filter;
    collectionFilter.sortField = sortField;
    collectionFilter.ascending = ascending;
    this.closeoutsDataSource.filter = collectionFilter;

    this.closeoutsDataSource.current();
  }

  displayCloseout(selectedCloseout) {
    this.setState({ selectedCloseout });
  }

  handleLogExport(e) {
    this.analyticsLogger.logCloseoutDocument('CloseoutDocumentDownloadedProjectSummary');
  }

  selectCloseout(maybeSelectedItem, maybeIsSelected) {
    let exportLink = null;
    const closeout = (typeof maybeSelectedItem == 'boolean') ? maybeIsSelected : maybeSelectedItem;
    const isSelected = (typeof maybeSelectedItem == 'boolean') ? maybeSelectedItem : maybeIsSelected;
    
    // first remove (regardless of isSelected)
    const selectedCloseouts = this.state.selectedCloseouts.filter((closeout_id) => {
      return closeout_id != closeout.id;
    });
    const selectedCloseoutsNames = this.state.selectedCloseoutsNames.filter((closeout_name) => {
     
      return closeout_name!= closeout.name;
    });
    if (isSelected) {
      selectedCloseouts.push(closeout.id);
      selectedCloseoutsNames.push(closeout.name);

    }
   
    let staticFilename='';
    if (selectedCloseouts.length > 0) {
      //const filename = "closeouts_" + (new Date()).toISOString().slice(0,10).replace(/-/g,"") + '.zip'
      // const filename = ""
      
      // if (this.state.fileName !=null){
      //   filename=this.state.fileName 
      // }
      // else{
      //    filename = "closeouts.zip"
      // }
      
      if (selectedCloseouts.length > 1){
        staticFilename = 'closeouts';
        this.setState({ closeoutFilename: staticFilename });
      }
      else{ 
       
        let name =selectedCloseoutsNames[0];
        let withoutExtension = name.split(/\.(?=[\w])/);
        staticFilename=withoutExtension[0];
        this.setState({ closeoutFilename: staticFilename });
      }
      exportLink = `${process.env.REACT_APP_API}/zip-closeouts?closeouts=${selectedCloseouts}&filename=${encodeURIComponent(staticFilename)}&current_company=${localStorage.current_company_id}&token=${localStorage.token}`;
    }
    this.setState({ selectedCloseouts, exportLink, closeoutFilename: staticFilename, selectedCloseoutsNames });
    
  }
  
  createTableHeader() {
    let caretTypes = [
      { type: 'name', headerName: 'CLOSEOUT FILENAME', first: true },
      { type: 'closeoutable_type', headerName: 'CLOSEOUT TYPE' },
      { type: 'project_name', headerName: 'PROJECT NAME' },
      { type: 'user_name', headerName: 'GENERATED BY' },
      { type: 'project_type_name', headerName: this.textMap.projectType.toUpperCase() },
      { type: 'status', headerName: 'STATUS' },
      { type: 'project_manager_name', headerName: this.textMap.projectManager.toUpperCase() },
      { type: 'created_at', headerName: 'DATE GENERATED' },
    ];

    const sortDirectionClass = this.state.ascending ? '' : 'down';

    return (
      <TableHeader
        accent={this.accent}
        sortDirectionClass={sortDirectionClass}
        handleSort={this.handleSort}
        sortedType={this.state.sortField}
        caretTypes={caretTypes}
        reportType={'closeout'}
      />
    );
  }

  createTableRows() {
    let even = false;

    const { closeouts } = this.state;

    return closeouts.map((closeout, i) => {
      even = !even;
      const rowClassName = 'closeout-summary-table__row'
        + (even ? ' closeout-summary-table__row--even' : '')
        + (closeout.status != 0 ? ' closeout-summary-table__row--in-progress' : '');

      return (
        <div key={closeout.id} className={rowClassName}>
          <TableRow
            hasCheckBox={true}
            selectedItem={closeout}
            even={even}
            select={this.displayCloseout}
            checked={this.selectCloseout}
            type={'closeout'}
            accent={this.accent} 
          />
        </div>
      );
    });
  }

  render() {
    const { selectedCloseout, exportLink, closeouts,selectedCloseouts } = this.state;
    if (!closeouts) {
      return isNull;
    }

    const closeoutSearchFilter = (
      <ReportFilter>
        <CloseoutReportFilters
          handleFilterChange={this.handleFilterChange}
          selectedFilters={this.closeoutsDataSource ? this.closeoutsDataSource.filter : {}}
        />
      </ReportFilter>
    );

    return (
      <div className='closeout-summary'>
        <ReportHeader
          reportTitle={'Closeouts'}
          minWidth={200}
          exportLink={exportLink}
          handleLogExport={this.handleLogExport}
          changeFileName={this.changeFileName}
          handleDownloadLocation={this.handleDownloadLocation}
          handleClosePopup={this.handleClosePopup}
          displayPopUp={this.state.displayPopUp}
          selectedCloseouts={selectedCloseouts}
          description={'closeoutSummary'}
          filename={this.state.closeoutFilename}
          handleFilterActive={this.handleFilterActive}
          filterActive={this.state.filterActive}
          filterDisplayed={this.state.filterDisplayed}
        />
        <div className='closeout-summary-table'
        ref={el => this.closeoutTableContainer = el}>     
          { closeoutSearchFilter }
          { this.createTableHeader() }
          {
            this.state.loadingCloseouts && <div className='loading-more-indicator'><LoadingDots accent={this.accent}/></div>
          }     
          <div className='closeout-summary-table__rows'>
            { this.createTableRows() }
          </div>
        </div>
        { selectedCloseout && 
          <DocumentPopup document={selectedCloseout} onClose={() => this.setState({ selectedCloseout: null })}/> 
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    permissions: state.new_users ? state.new_users.permissions : null,
    currentUser: state.new_users.currentUser,
    currentCompany: state.new_companies.currentCompany,
  };
};

export default connect(mapStateToProps)(CloseoutSummary);



// WEBPACK FOOTER //
// ./src/containers/ProjectSummaryContainer/CloseoutSummary/index.js